export const REMEMBER_LOGIN = "REMEMBER_LOGIN";
export const LOGGED_IN = "LOGGED_IN";

export const TURBINE_VIEW_MODES = Object.freeze({
  GRID: "grid layout",
  MAP: "map",
  LIST: "list layout",
});

export const WIND_TURBINE_ACTION = Object.freeze({
  STOP: "STOP",
  RESET: "RESET",
  MOTOR_START: "MOTOR_START",
  MOTOR_TOGGLE: "MOTOR_TOGGLE",
  YAW_CLOCKWISE: "YAW_CLOCKWISE",
  YAW_COUNTER_CLOCKWISE: "YAW_COUNTER_CLOCKWISE",
  EDIT_PARAMETER: "EDIT_PARAMETER",
  RESET_EVENT_LOGS: "RESET_EVENT_LOGS",
  RESET_ENERGY_COUNTERS: "RESET_ENERGY_COUNTERS",
  RESET_PEAK_VALUES: "RESET_PEAK_VALUES",
  RESET_POWER_CURVE: "RESET_POWER_CURVE",
  RESTART_CONTROLLER: "RESTART_CONTROLLER",
  UPDATE_VIB_SENSOR: "UPDATE_VIB_SENSOR",
  RESET_DEBUG_DATA: "RESET_DEBUG_DATA",
});

// Schema-driven turbines (TurbineSchemaRegister coils) don't have a
// live/advanced permission tier per command like the legacy Command sheet
// does (permission 0/1) - this is the equivalent split for them, curated to
// the commands operators need day-to-day in the Live tab. Everything else
// moves to Advanced > Advanced Controls.
export const LIVE_CORE_COMMANDS = [
  "start", // RAGO 60kW - pulse on coil 100 (2026-10-21 request)
  "stop",
  "reset",
  "motor_start",
  "mode_toggle",
  "yaw_cw",
  "yaw_ccw",
  "ack_error", // Vestas (PF2) - Controls tab's "Error Ack" button, ToDo.md item 2
];

export const CHART_TYPE = Object.freeze({
  Hourly: "Hourly",
  Daily: "Daily",
  Monthly: "Monthly",
  PowerCurve: "Power curve",
});

export const SET_VIEW_MODE = "SET_VIEW_MODE";
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_TOTAL_PAGE_NUMBER = "SET_TOTAL_PAGE_NUMBER";
export const ITEMS_PER_PAGE = 12;
export const SET_THEME = "SET_THEME";
export const THEME = "THEME";
export const SET_IS_IDLE = "SET_IS_IDLE";
export const LOAD_WIND_TURBINES = "LOAD_WIND_TURBINES";
export const LOAD_WIND_TURBINE = "LOAD_WIND_TURBINE";
export const TURBINE_LAST_UPDATE = "TURBINE_LAST_UPDATE";

// How long without live data before a turbine shows "Timeout" (card banner
// and header). Was 18s in two places - raised to 45s (2026-10-06): the
// server was receiving telemetry every ~1s with no gap over 18s, yet cards
// flipped to Timeout often - browser-side delays (socket.io transport, tabs
// in the background) plus clock skew ate the whole 18s margin.
export const TURBINE_DATA_TIMEOUT_MS = 45000;
export const TURBINE_STATUS_UPDATE = "TURBINE_STATUS_UPDATE";
export const LIVE_PARAMS_UPDATE = "LIVE_PARAMS_UPDATE";
export const PARAM_UPDATE = "PARAM_UPDATE";
// localhost:4000 only ever works from a browser running on the same
// machine as the server itself - every real user's browser has nothing
// listening there, so every API call (including /auth/login) fails
// outright. LoginForm.js's onLoginError doesn't distinguish a network
// failure from an actual 401, so this surfaced as "Invalid credentials"
// regardless of what was typed - the same bug already found in
// Orbital-admin's constants.js, apparently made twice.
export const API_URL = "https://oadmins.italscada.com";
export const SOCKET_URL = "wss://oadmins.italscada.com";

//export const API_URL = "http://localhost:4000";
//export const SOCKET_URL = "ws://localhost:4000";

//export const API_URL = 'https://orbitalscada.devtelsoftware.com/api';
//export const SOCKET_URL = 'wss://orbitalscada.devtelsoftware.com';
